import React from 'react';
import GithubUser from './GithubUser/GithubUser';
import './App.css';

function App() {
  return (
     <GithubUser/>
  );
}

export default App;
